import React, {forwardRef} from 'react'
import clsx from '../../../../helpers/clsx'

export const NoData = forwardRef(({className, ...rest}, ref) => {
    return (
        <p className={clsx('NoData', className)} ref={ref} {...rest}>
            No shapes yet
        </p>
    )
})

export default NoData
